import HistoricalRiskDashboardPage from './HistoricalRiskDashboardPage';
export { HistoricalRiskDashboardPage };
export default HistoricalRiskDashboardPage;
